module.exports = __webpack_public_path__ + "static/media/faq5.c50b9cec.jpeg";